<template>
<router-view />
</template>

<script setup lang="ts" name="TopoLayout">

</script>
